module.exports = __webpack_public_path__ + "img/6left-491a7ee7.png";